import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { personalizationDeferredToCheckout } from '../../utils/personalizationOffer';
import {
  selectCartContainsNonIncentiveProducts,
  selectCartContainsPersonalizableProducts,
  selectEligibleIncentivesForCart,
  selectEligibleIncentivesForOrder,
  selectPreCartOfferProductsToPrompt,
  selectShouldPromptForPersonalization,
} from '../../selectors';

const PreCartOffers = ({ children, history }) => {
  const [checksComplete, setChecksComplete] = useState(false);

  const prepayPersonalizationOfferType = useSelector(
    (state) => state.shoot.prepayPersonalizationOfferType,
  );
  const eventIsPrepay = useSelector((state) => state?.shoot?.shoot?.is_prepay);

  const eligibleIncentivesForCart = useSelector(
    selectEligibleIncentivesForCart,
  );
  const eligibleIncentivesForOrder = useSelector(
    selectEligibleIncentivesForOrder,
  );
  const preCartOfferProductsToPrompt = useSelector(
    selectPreCartOfferProductsToPrompt,
  );
  const cartContainsNonIncentiveProducts = useSelector(
    selectCartContainsNonIncentiveProducts,
  );
  const cartContainsPersonalizableProducts = useSelector(
    selectCartContainsPersonalizableProducts,
  );
  const shouldPromptForPersonalization = useSelector(
    selectShouldPromptForPersonalization,
  );

  useEffect(() => {
    if (
      cartContainsNonIncentiveProducts &&
      (eligibleIncentivesForCart?.length > 0 ||
        eligibleIncentivesForOrder?.length > 0)
    ) {
      console.log('pushing to incentives config from cart-based check');
      history.push('/v3/incentives/config');
    } else if (
      // The other half of the rule the config flows suppress on — see
      // utils/personalizationOffer. `eventIsPrepay` reads the nested
      // shoot.shoot.is_prepay mirror this component already uses.
      personalizationDeferredToCheckout({
        isPrepay: eventIsPrepay,
        prepayPersonalizationOfferType,
      }) &&
      cartContainsPersonalizableProducts &&
      shouldPromptForPersonalization
    ) {
      if (eventIsPrepay === false) {
        // TODO: revist this logic
        // Don't show the personalization offer if the event is not prepay
        setChecksComplete(true);
      } else {
        history.push('/v3/personalization-offer');
      }
    } else if (preCartOfferProductsToPrompt.length > 0) {
      history.push('/v3/pre-cart-offers');
    } else {
      setChecksComplete(true);
    }
  }, [
    cartContainsNonIncentiveProducts,
    eligibleIncentivesForCart,
    eligibleIncentivesForOrder,
    eventIsPrepay,
    prepayPersonalizationOfferType,
    cartContainsPersonalizableProducts,
    shouldPromptForPersonalization,
    preCartOfferProductsToPrompt,
  ]);

  if (checksComplete) {
    return children;
  }

  // TODO: render loading spinner
  return <div>Loading...</div>;
};

export default PreCartOffers;
